"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/http");
var _1 = require(".");
var router_1 = require("@angular/router");
var platform_browser_1 = require("@angular/platform-browser");
var LocalizationService = (function () {
    function LocalizationService(http, title, progressService, eventService, router, activatedRoute, resourcePreloaderService) {
        this.http = http;
        this.title = title;
        this.progressService = progressService;
        this.eventService = eventService;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.resourcePreloaderService = resourcePreloaderService;
        this.langsArrayShort = ['ru', 'en'];
        this.copyright = new Date().getFullYear() + " HIL";
        this.langsArray = ['Русский', 'English'];
        this.langsObject = {
            ru: 'Русский',
            en: 'English'
        };
        this.loadingText = {
            en: 'Загрузка...',
            ru: 'Loading...'
        };
        this.getLocals();
    }
    LocalizationService.prototype.setRouterLinks = function () {
        var langsLinks = [];
        var path = window.location.pathname.split('/').slice(2);
        for (var _i = 0, _a = this.langsArrayShort; _i < _a.length; _i++) {
            var lang = _a[_i];
            langsLinks.push(['/' + lang].concat(path).join('/'));
        }
        return langsLinks;
    };
    LocalizationService.prototype.getLevelLocals = function () {
        var _this = this;
        return this.http.get(require("../resources/localizable/" + this.currentLang + "-lproj/LevelInfos.xml"))
            .toPromise()
            .then(function (response) {
            return _this.parseLevelInfos(response);
        }).catch(function (error) { return console.log(error + " ---> localization.service - level"); });
    };
    LocalizationService.prototype.getLocals = function () {
        this.currentLang = this.getCurrentLang();
        this.currentLangLinkAppStore = this.getCurrentLangAppStore();
        this.interfaceLocals = this.getInterfaceLocals();
        this.toolsLocals = this.getToolsLocals();
        this.hotKeysLocals = this.getHotKeysLocals();
        this.levelLocals = this.getLevelLocals();
        this.eventService.fire('changeLocals'); // say to update models
    };
    LocalizationService.prototype.setTitleInHead = function (name) {
        if (name === void 0) { name = ''; }
        var title = name ? "Euclidea - " + name : 'Euclidea';
        this.title.setTitle(title);
    };
    LocalizationService.prototype.getRootUrl = function () {
        return window.location.pathname.split('/').slice(0, 4).join('/');
    };
    LocalizationService.prototype.getRootUrlForLevel = function () {
        var url = window.location.pathname.split('/');
        if (url.indexOf('packs') === -1) {
            return url.slice(0, 3).join('/') + '/packs';
        }
        return url.slice(0, 4).join('/');
    };
    LocalizationService.prototype.getInterfaceLocals = function () {
        return this.httpGet(require("../resources/localizable/" + this.currentLang + "-lproj/Localizable.strings"));
    };
    LocalizationService.prototype.getHotKeysLocals = function () {
        return this.httpGet(require("../resources/localizable/" + this.currentLang + "-lproj/HotKeys.strings"));
    };
    LocalizationService.prototype.httpGet = function (url) {
        var _this = this;
        return this.http
            .get(url)
            .toPromise()
            .then(function (response) {
            return _this.parseData(response);
        }).catch(function (error) {
            console.log(error + " ---> localization.service");
        });
    };
    LocalizationService.prototype.getToolsLocals = function () {
        var _this = this;
        if (this.currentLang === 'en') {
            return this.resourcePreloaderService.toolInfosPromise.then(function (toolInfos) {
                return _this.parseToolsInfos(toolInfos);
            });
        }
        return this.http
            .get(require("../resources/localizable/" + this.currentLang + "-lproj/ToolInfos.xml"))
            .toPromise()
            .then(function (response) {
            return _this.parseToolsInfos(response.text());
        }).catch(function (error) { return console.log(error + " ---> localization.service - tools"); });
    };
    LocalizationService.prototype.getCurrentLang = function () {
        var lang;
        var url = location.pathname;
        var match = url.match(/^\/([A-Za-z]{2})([\/\?].*)?$/i);
        if (match && this.langsArrayShort.indexOf(match[1]) > -1) {
            lang = match[1];
            this.progressService.sharedPreferences.local = lang;
            this.progressService.saveSharedPreferences();
            return lang;
        }
        if (this.progressService.sharedPreferences.local) {
            return this.progressService.sharedPreferences.local;
        }
        else {
            lang = navigator.browserLanguage || navigator.language || navigator.userLanguage;
            if (lang.length > 2) {
                lang = lang.substr(0, 2);
            }
            if (this.langsArrayShort.indexOf(lang) === -1) {
                lang = 'en';
            }
            this.progressService.sharedPreferences.local = lang;
            this.progressService.saveSharedPreferences();
            return lang;
        }
    };
    LocalizationService.prototype.getCurrentLangAppStore = function () {
        return this.currentLang === 'en' ? '/' : "/" + this.currentLang + "/";
    };
    LocalizationService.prototype.parseData = function (response) {
        var localsObj = {};
        var localRegExp = /^"(.+)" = "(.+)";$/g;
        var result = response.text().replace(/\r\n/gm, '\n');
        var strings = result.split('\n');
        for (var _i = 0, strings_1 = strings; _i < strings_1.length; _i++) {
            var str = strings_1[_i];
            str = str.replace(/\\n/gm, '<br>').replace(/\\/g, '');
            localRegExp.lastIndex = 0;
            if (localRegExp.test(str)) {
                localRegExp.lastIndex = 0;
                var execRes = localRegExp.exec(str);
                localsObj[execRes[1]] = execRes[2];
            }
        }
        return localsObj;
    };
    LocalizationService.prototype.parseToolsInfos = function (response) {
        var localsObj = {};
        var parser = new DOMParser();
        var xmlData = parser.parseFromString(response, "application/xml");
        for (var _i = 0, _a = xmlData.querySelectorAll('tool'); _i < _a.length; _i++) {
            var tool = _a[_i];
            localsObj[tool.getAttribute('id')] = {
                title: tool.getAttribute('title'),
                cost: tool.getAttribute('cost')
            };
        }
        return localsObj;
    };
    LocalizationService.prototype.parseLevelInfos = function (response) {
        var localsObj = {};
        var parser = new DOMParser();
        var xmlData = parser.parseFromString(response.text(), "application/xml");
        for (var _i = 0, _a = xmlData.querySelectorAll('level'); _i < _a.length; _i++) {
            var level = _a[_i];
            localsObj[level.getAttribute('id')] = {
                title: level.getAttribute('title'),
                description: level.getAttribute('description'),
                quote: level.getAttribute('quote'),
                quoteAuthor: level.getAttribute('quote_author')
            };
        }
        return localsObj;
    };
    return LocalizationService;
}());
LocalizationService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http,
        platform_browser_1.Title,
        _1.ProgressService,
        _1.EventService,
        router_1.Router,
        router_1.ActivatedRoute,
        _1.ResourcePreloaderService])
], LocalizationService);
exports.LocalizationService = LocalizationService;



//////////////////
// WEBPACK FOOTER
// ./src/services/localization.service.ts
// module id = 261
// module chunks = 0